import './errorBoundary.scss';

import LoadingButton from '@mui/lab/LoadingButton';
import { uniqueId } from 'lodash';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

import ErrorImg from '../../assets/hero-error-with-smoke.svg';

/**
 * ErrorBoundary
 * This component is used to catch any errors that bubble up from both the router level and the component level.
 */
const ErrorBoundary = (): JSX.Element => {
  //const { captureException } = useErrorReporting();
  const { t } = useTranslation();
  const error = useRouteError();

  // const errorMessage = get(error, 'message');
  // const errorStack = get(error, 'stack');

  useEffect(() => {
    //captureException(errorMessage, errorStack);
  }, [error]);

  const redirectToDashboard = (): void => {
    window.location.assign('/dashboard/garage');
  };

  return (
    <div className="error-container">
      <div className="error-img">
        <img alt={t('imageAlts.heroErrorWithSmoke')} src={ErrorImg} />
      </div>

      <div className="error-text">
        <h1>{t('errorBoundary.title')}</h1>
        <h2>
          <Trans
            components={[<br key={uniqueId('br-')} />]}
            i18nKey={'errorBoundary.subtitle'}
          />
        </h2>
      </div>

      <div>
        <LoadingButton
          type="button"
          variant="contained"
          onClick={redirectToDashboard}
        >
          {t('errorBoundary.dashboard')}
        </LoadingButton>
      </div>
    </div>
  );
};

export default ErrorBoundary;
